import { AbsoluteFill, Easing, interpolate, useCurrentFrame } from 'remotion';

// Ink curtain sweeps upward revealing the card (top-to-bottom reveal)
export const InkWipeComposition: React.FC = () => {
  const frame = useCurrentFrame();

  // translateY: 0% (covering) → -100% (fully gone above)
  const translateY = interpolate(frame, [0, 36], [0, -100], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
    easing: Easing.bezier(0.76, 0, 0.24, 1),
  });

  const edgeOpacity = interpolate(frame, [0, 5, 30, 36], [0, 1, 0.6, 0], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  return (
    <AbsoluteFill style={{ overflow: 'hidden' }}>
      {/* Ink curtain */}
      <AbsoluteFill
        style={{
          background: '#050505',
          transform: `translateY(${translateY}%)`,
        }}
      >
        {/* Gold leading edge sits at the bottom of the curtain */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 3,
            background: `rgba(212, 175, 55, ${edgeOpacity})`,
          }}
        />
      </AbsoluteFill>
    </AbsoluteFill>
  );
};
